import React from 'react'
import { Pill } from './pill'
import { formatAgo, formatDateTime } from './format'

// The "Credential accepted" check (GET /provider-health's credentialCheck):
// whether the identity provider accepts the credential sign-in presents,
// proven with a client-credentials request and nobody signing in. The
// server writes the words (summary, fix); this only picks a tone and a
// short label per status.
const VIEW = {
  accepted: { tone: 'ok', label: 'Accepted' },
  not_registered: { tone: 'bad', label: 'Not registered' },
  secret_invalid: { tone: 'bad', label: 'Secret not valid' },
  secret_expired: { tone: 'bad', label: 'Secret expired' },
  app_not_found: { tone: 'bad', label: 'App not found' },
  client_id_wrong: { tone: 'bad', label: 'Client ID wrong' },
  rejected: { tone: 'bad', label: 'Rejected' },
  not_configured: { tone: 'bad', label: 'Not set up' },
  not_checked: { tone: null, label: 'Not checked' },
  unreachable: { tone: 'warn', label: "Couldn't reach" },
  inconclusive: { tone: 'warn', label: "Couldn't tell" }
}

const NOT_CHECKED = { tone: null, label: 'Not checked' }

export const credentialCheckView = check => (check && VIEW[check.status]) || NOT_CHECKED

// True when the identity provider refused the credential: sign-in fails.
export const credentialRejected = check => credentialCheckView(check).tone === 'bad'

// The whole result: pill, what we found, how to fix it, and which
// certificate it was about. `check` undefined means still loading; null
// means the health check itself couldn't be read.
export const CredentialCheckResult = ({ check, compact = false }) => {
  if (check === undefined) return <p className="sw-hint m-0" role="status">Checking whether the identity provider accepts the credential…</p>
  if (check === null) return <p className="sw-hint m-0">The credential check couldn't be loaded.</p>
  const view = credentialCheckView(check)
  return (
    <div className={`sw-credcheck ${view.tone || ''}`.trim()} data-testid="credential-check" data-status={check.status}>
      <div className="sw-credcheck-head">
        {!compact && <span className="sw-credcheck-title">Credential accepted</span>}
        <Pill tone={view.tone}>{view.label}</Pill>
      </div>
      {check.summary && <p className="m-0">{check.summary}</p>}
      {check.fix && <p className="m-0"><span className="fw-semibold">To fix: </span>{check.fix}</p>}
      {(check.thumbprint || check.code || check.checkedAt) &&
        <p className="sw-credcheck-meta m-0">
          {check.thumbprint && <span>Certificate thumbprint (SHA-1) <code className="sw-mono">{check.thumbprint}</code></span>}
          {check.code && <span>Answer <code className="sw-mono">{check.code}</code></span>}
          {check.checkedAt && <span title={formatDateTime(check.checkedAt)}>Checked {formatAgo(check.checkedAt)}</span>}
        </p>}
    </div>
  )
}
